module.exports = __webpack_public_path__ + "static/media/ic_search-primary.ef15a427.svg";